<template>
  <div class="wrapper-safe">
    <el-card shadow="always">
      <el-card style="margin: 30px 0 0 0">
        <el-row>
          <el-tabs v-model="activeName">
            <!-- /* ---------------------------------- 谷歌绑定 ---------------------------------- */ -->
            <el-tab-pane :label="$t('passwd.label.bindgoogle')" name="1">
              <div class="QRcode">
                <div v-if="!isBindGoogle">
                  <p>{{ $t('merchantdetails.merchantcode') }}</p>
                  <img :src="imgUrl" style="width: 300px; height: 300px" alt="" />
                </div>
                <div v-else>
                  <p>{{ $t('merchantdetails.merchantkey') }}</p>
                  <p>
                    {{ merchantinfo.merchantKey }}
                  </p>
                </div>
                <div>
                  <el-form ref="form2" :model="form2">
                    <el-form-item prop="code" :label="$t('merchantdetails.scan')">
                      <el-input
                        :disabled="isBindGoogle"
                        v-model.trim="form2.code"
                        :placeholder="$t('merchantdetails.authcode')"
                      ></el-input>
                    </el-form-item>
                    <span>
                      <el-button :disabled="isBindGoogle" type="primary" @click="doAuth('form2')">{{
                        $t('accountmanager.confirm')
                      }}</el-button>
                    </span>
                  </el-form>
                </div>
              </div>
            </el-tab-pane>

            <!-- /* --------------------------------- 重置登陆密码 --------------------------------- */ -->
            <el-tab-pane :label="$t('passwd.label.resetPass')" name="2">
              <el-form :model="form" v-bind="propbind.form">
                <template v-if="isAuth">
                  <el-form-item prop="oldPasswd" :label="$t('passwd.label.oldPasswd')">
                    <el-input
                      v-model.trim="form.oldPasswd"
                      type="password"
                      :placeholder="$t('passwd.placeholder.oldPasswd')"
                    />
                  </el-form-item>
                  <el-form-item prop="newPasswd" :label="$t('passwd.label.newPasswd')">
                    <el-input
                      v-model.trim="form.newPasswd"
                      type="password"
                      :placeholder="$t('passwd.placeholder.newPasswd')"
                    />
                  </el-form-item>
                  <el-form-item prop="reNewPasswd" :label="$t('passwd.label.reNewPasswd')">
                    <el-input
                      v-model.trim="form.reNewPasswd"
                      type="password"
                      :placeholder="$t('passwd.placeholder.reNewPasswd')"
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="updatePasswd">
                      {{ $t('btns.confirm') }}
                    </el-button>
                  </el-form-item>
                </template>

                <template v-else>
                  <el-form-item prop="code" :label="$t('passwd.label.bindgoogle')">
                    <el-input
                      maxlength="6"
                      v-model.trim="form.code"
                      :placeholder="$t('passwd.placeholder.bindgoogle')"
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="doValid('form')">
                      {{ $t('btns.confirm') }}
                    </el-button>
                  </el-form-item>
                </template>
              </el-form>
            </el-tab-pane>
            <!-- /* --------------------------- 修改密码这里是管理员的话就只有登录密码 -------------------------- */ -->
            <el-tab-pane :label="$t('passwd.label.resetPay')" name="3" style="height: 500px">
              <el-form :model="form1" v-bind="propbind.form1">
                <template v-if="isAuth">
                  <el-form-item prop="oldPasswd" :label="$t('passwd.label.oldPasswd')">
                    <el-input
                      v-model.trim="form1.oldPasswd"
                      type="password"
                      :placeholder="$t('passwd.placeholder.oldPasswd')"
                    />
                  </el-form-item>
                  <el-form-item prop="newPasswd" :label="$t('passwd.label.newPasswd')">
                    <el-input
                      v-model.trim="form1.newPasswd"
                      type="password"
                      :placeholder="$t('passwd.placeholder.newPasswd')"
                    />
                  </el-form-item>
                  <el-form-item prop="reNewPasswd" :label="$t('passwd.label.reNewPasswd')">
                    <el-input
                      v-model.trim="form1.reNewPasswd"
                      type="password"
                      :placeholder="$t('passwd.placeholder.reNewPasswd')"
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-button type="primary" @click="resetpassword">
                      {{ $t('btns.confirm') }}
                    </el-button>
                  </el-form-item>
                </template>
                <template v-else>
                  <el-form-item prop="code" :label="$t('passwd.label.bindgoogle')">
                    <el-input
                      maxlength="6"
                      v-model.trim="form1.code"
                      :placeholder="$t('passwd.placeholder.bindgoogle')"
                    />
                  </el-form-item>
                  <el-form-item>
                    <el-button @click="doValid('form1')">
                      {{ $t('btns.confirm') }}
                    </el-button>
                  </el-form-item>
                </template>
              </el-form>
            </el-tab-pane>
          </el-tabs>
        </el-row>
      </el-card>
    </el-card>
  </div>
</template>

<script>
import passwdApi from '@/api/passwd';
import depositApi from '@/api/merchantdeposit';
import { doValid, doAuth } from '@/api/auth';

import { checkPass } from '@/utils/validate';
import { mapState } from 'vuex';
export default {
  name: 'safeCenter',
  data() {
    return {
      isAuth: false, //是否验证google开关
      dialogVisible: false,
      active: 0,
      activeName: '1',

      form: {},
      form1: {},
      form2: {},

      merchantinfo: {},
      secretObj: {}
    };
  },
  computed: {
    ...mapState({
      info: ({ user }) => user.info
    }),
    imgUrl() {
      return 'data:image/png;base64,' + this.secretObj.secretQr;
    },
    isBindGoogle() {
      // 0 未绑定， 1 绑定
      if (this.merchantinfo.googleAuthStatus === undefined) {
        return true;
      } else {
        return this.merchantinfo.googleAuthStatus === 0 ? false : true;
      }
    }
  },

  created() {
    this.init();
  },
  mounted() {},
  methods: {
    init() {
      this.getMerchantInfo();
      this.handleEmpty();
      this.propbind = {
        form: {
          ref: 'form',
          rules: {
            code: {
              required: true,
              message: this.$t('merchantdetails.codenull'),
              trigger: 'blur'
            },
            oldPasswd: [
              {
                required: true,
                message: this.$t('passwd.rules.oldPasswd.required'),
                trigger: 'blur'
              },
              {
                validator: (rules, value, cb) => {
                  if (!checkPass(value)) {
                    cb(new Error(this.$t('passwd.rules.oldPasswd.format')));
                  } else {
                    cb();
                  }
                },
                trigger: 'blur'
              }
            ],
            newPasswd: [
              {
                required: true,
                message: this.$t('passwd.rules.newPasswd.required'),
                trigger: 'blur'
              },
              {
                validator: (rules, value, cb) => {
                  if (!checkPass(value)) {
                    cb(new Error(this.$t('passwd.rules.newPasswd.format')));
                  } else {
                    cb();
                  }
                },
                trigger: 'blur'
              }
            ],
            reNewPasswd: [
              {
                required: true,
                message: this.$t('passwd.rules.reNewPasswd.required'),
                trigger: 'blur'
              },
              {
                validator: (rules, value, cb) => {
                  if (!checkPass(value)) {
                    cb(new Error(this.$t('passwd.rules.reNewPasswd.format')));
                  } else if (value !== this.form.newPasswd) {
                    cb(new Error(this.$t('passwd.rules.reNewPasswd.same')));
                  } else {
                    cb();
                  }
                },
                trigger: 'blur'
              }
            ]
          }
        },
        form1: {
          ref: 'form1',
          rules: {
            code: {
              required: true,
              message: this.$t('merchantdetails.codenull'),
              trigger: 'blur'
            },
            oldPasswd: [
              {
                required: true,
                message: this.$t('passwd.rules.oldPasswd.required'),
                trigger: 'blur'
              },
              {
                validator: (rules, value, cb) => {
                  if (!checkPass(value)) {
                    cb(new Error(this.$t('passwd.rules.oldPasswd.format')));
                  } else {
                    cb();
                  }
                },
                trigger: 'blur'
              }
            ],
            newPasswd: [
              {
                required: true,
                message: this.$t('passwd.rules.newPasswd.required'),
                trigger: 'blur'
              },
              {
                validator: (rules, value, cb) => {
                  if (!checkPass(value)) {
                    cb(new Error(this.$t('passwd.rules.newPasswd.format')));
                  } else {
                    cb();
                  }
                },
                trigger: 'blur'
              }
            ],
            reNewPasswd: [
              {
                required: true,
                message: this.$t('passwd.rules.reNewPasswd.required'),
                trigger: 'blur'
              },
              {
                validator: (rules, value, cb) => {
                  if (!checkPass(value)) {
                    cb(new Error(this.$t('passwd.rules.reNewPasswd.format')));
                  } else if (value !== this.form1.newPasswd) {
                    cb(new Error(this.$t('passwd.rules.reNewPasswd.same')));
                  } else {
                    cb();
                  }
                },
                trigger: 'blur'
              }
            ]
          }
        },
        form2: {
          ref: 'form2',
          rules: {
            code: {
              required: true,
              message: this.$t('merchantdetails.codenull'),
              trigger: 'blur'
            }
          }
        }
      };
    },

    handleEmpty() {
      this.form = {
        code: '',
        oldPasswd: '',
        newPasswd: '',
        reNewPasswd: ''
      };
      this.form1 = {
        code: '',
        oldPasswd: '',
        newPasswd: '',
        reNewPasswd: ''
      };
      this.form2 = {
        code: ''
      };
    },

    async getMerchantInfo() {
      const params = {
        merchantNo: this.info.userName
      };
      const { data } = await depositApi.getmerchantNo(params);
      if (data) {
        if (data.code === 200) {
          this.merchantinfo = data.data || {};
          this.Obtain();
        } else {
          this.$message.error(this.$t('status.error'));
        }
      }
    },

    // 获取二维码
    async Obtain() {
      const { data } = await this.$http.get('/merchant/captcha/qr');
      if (data) {
        if (data.code === 200) {
          this.secretObj = data.data;
        } else {
          this.$message.error(data.msg);
        }
      }
    },
    doAuth(form) {
      this.$refs[form].validate(async (valid) => {
        if (valid) {
          const code = this[form].code;
          if (!code) return this.$message.error(this.$t('merchantdetails.codenull'));
          const { data } = await doAuth({ code });
          if (data) {
            if (data.code === 200) {
              this.getMerchantInfo();
            } else {
              this.$message.error(data.msg);
            }
          }
          this.form2.code = '';
        }
      });
    },
    // 调用之前先获取二维码
    // 商户谷歌身份认证器认证
    async doValid(form) {
      const code = this[form].code;
      if (!code) return this.$message.error(this.$t('merchantdetails.codenull'));
      const { data } = await doValid({ code });
      if (data) {
        if (data.code === 200) {
          this.isAuth = true;
          this.form.code = '';
        } else {
          this.$message.error(data.msg);
        }
      }
    },
    goBack() {
      this.$router.go(-1);
    },
    updatePasswd() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          const params = {
            id: this.info.id,
            newPassword: this.form.newPasswd,
            oldPassword: this.form.oldPasswd
          };
          const { data } = await passwdApi.updatePasswd(params);
          if (data) {
            if (data.code === 200) {
              this.$message.success(this.$t('status.success'));
              this.$router.push({ name: 'login' });
            } else {
              this.$message.error(data.msg);
            }
          }
        }
      });
    },
    async resetpassword() {
      this.$refs.form1.validate(async (valid) => {
        if (valid) {
          const params = {
            merchantNo: this.info.userName,
            newPassword: this.form1.newPasswd,
            oldPassword: this.form1.oldPasswd
          };
          const { data } = await passwdApi.updatePay(params);
          if (data) {
            if (data.code === 200) {
              this.$message.success(this.$t('status.success'));
              this.handleEmpty();
              this.activeName = 1;
            } else {
              this.$message.error(data.msg);
            }
          }
        }
      });
    }
  }
};
</script>

<style lang="scss" scoped></style>



// WEBPACK FOOTER //
// src/components/safe-center/index.vue